import React from 'react';
import ManageRolesHeader from './managerolesheader';
import RoleList from './rolelist';
import {labels} from '../../../../../util/uiconstants';
import styled from 'styled-components';
import Loader from '@ey/loader';

function ManageRolesTable(props) {
	return (
		<Headerbody className="managerolepageview mainResponsiveWrapper">
			{props.isLoading ? (
				<Loader show view="blockView" styleName="loadingstyle" />
			) : (
				<section className="userlistwrapper manageaccessheader">
					<ManageRolesHeader />
					{props.data?.length > 0 ? (
						<RoleList list={props.data} onDeleteClick={props.onDeleteClick} />
					) : (
						<section className="contentHistoryPlaceHolderText norecord">
							{props.rolesExist
								? labels.noRoleResults
								: labels.manageAccessNoRolesAdded}
						</section>
					)}
				</section>
			)}
		</Headerbody>
	);
}

const Headerbody = styled.section`
	// common for table UI start

	.userlistwrapper {
		display: inline-block;
		width: 100%;

		&.manageaccessheader {
			.userlist-header {
				.userlistitem {
					width: 24%;
					height: var(--px-48);
				}
				.delete {
					width: 4%;
					text-align: center;
				}
			}
			.userlist-body {
				height: calc(100vh - var(--px-390));
			}
		}

		.contentHistoryPlaceHolderText {
			border: var(--px-1) solid var(--neutrals-200);
		}

		.manageaccessitemview {
			width: 100%;
			display: flex;
			border-collapse: collapse;
			align-items: center;
			justify-content: center;
			border-bottom: var(--px-1) solid var(--neutrals-200);

			&.inactive mgt-person {
				color: var(--neutrals-300);
			}

			&:not(.inactive) .userName {
				color: var(--neutrals-900);
			}

			.userlistitem {
				width: 24% !important;
				height: var(--px-48);
			}

			.grid {
				display: grid;
				grid-template-columns: auto 1fr;
				grid-gap: 0 10px;

				&.delete {
					text-align: center;
					width: 4% !important;
					.description {
						display: inline-flex;
					}
				}
			}

			&:last-child {
				border-bottom: none;
			}
		}

		.userlist-header {
			width: 100%;
			display: inline-block;
			.userlistheader {
				display: flex;
				border-collapse: collapse;
				background: var(--neutrals-50);
				border: var(--px-1) solid var(--neutrals-200);
				border-radius: var(--px-8) var(--px-8) 0 0;
				border-bottom: none;
			}
		}

		.userlist-body {
			overflow: auto;
			display: inline-block;
			width: 100%;
			border: var(--px-1) solid var(--neutrals-200);
			border-radius: 0 0 var(--px-8) var(--px-8);			
			background: var(--neutrals-00white);
		}

		.userlist-header,
		.userlist-body {
			.userlistitem {
				padding: var(--px-10);
				flex: 1 1 auto;
				width: 15%;
				height: var(--px-48);
				display: flex;
				align-items: center;

				.description {
					display: flex;

					svg.delete {
						cursor: pointer;
					}
				}

				.ellipses {
					display: flex;
				}

				&.date,
				&.status {
					width: 6%;

					.ellipses {
						vertical-align: middle;
						line-height: normal;
					}
				}

				.engname {
					width: 100%;
					display: inline-grid;

					.ellipses {
						line-height: normal;
					}
				}
			}
		}
	}

	// common for table UI end
`;

export default ManageRolesTable;
